import { withoutRetiredPromptedInputs } from '../policy_feature/inputs'
import { getAutoModeApplicationInputs } from './ApplicationRequirements/useApplicationFieldRequirements'
import { getAutoModeAuthenticationContextInputs } from './AuthenticationContextRequirements/useAuthenticationContextFieldRequirements'
import { getAutoModeCustomAuthenticationFactorInputs } from './CustomAuthenticationFactorRequirements/useCustomAuthenticationFactorFieldRequirements'
import { getAutoModeRoleInputs } from './DirectoryRoleRequirements/useRoleFieldRequirements'
import { getAutoModeGroupInputs } from './GroupRequirements/useGroupFieldRequirements'
import { getAutoModeNamedLocationInputs } from './NamedLocationRequirements/useNamedLocationFieldRequirements'
import { getAutoModeServicePrincipalInputs } from './ServicePrincipalRequirements/useServicePrincipalFieldRequirements'
import { getAutoModeUserInputs } from './UserRequirements/useUserFieldRequirements'

// A group/named-location/application/user/directory-role/authentication-context/service-principal
// field resolved via an attached requirement isn't manually prompted at deploy, so it's
// deliberately absent from the template's own stored `promptedInputs` (see
// PolicyTemplateDetailsModal's own setup) — passing that raw, stored list straight through always
// shows "None" for "Automatically resolved" and omits the field entirely, even though the
// template's own edit view computes and shows it correctly. This mirrors that same computation so
// every read-only view of a saved template matches the edit view.
const getDisplayPromptedInputs = (template) => {
  const policyBody = template?.meta_data?.policyBody
  const storedPromptedInputs = withoutRetiredPromptedInputs(template?.meta_data?.promptedInputs)

  const requiredByInput = Object.fromEntries(storedPromptedInputs.map((input) => [input.name, input.required]))
  const notesByInput = Object.fromEntries(storedPromptedInputs.map((input) => [input.name, input.notes]))

  const autoResolvedInputs = new Set([
    ...getAutoModeGroupInputs(policyBody),
    ...getAutoModeNamedLocationInputs(policyBody),
    ...getAutoModeApplicationInputs(policyBody),
    ...getAutoModeUserInputs(policyBody),
    ...getAutoModeRoleInputs(policyBody),
    ...getAutoModeAuthenticationContextInputs(policyBody),
    ...getAutoModeServicePrincipalInputs(policyBody),
    ...getAutoModeCustomAuthenticationFactorInputs(policyBody),
  ])

  const inputNames = new Set([...storedPromptedInputs.map((input) => input.name), ...autoResolvedInputs])

  return Array.from(inputNames).map((name) => ({
    name,
    required: requiredByInput[name],
    notes: notesByInput[name] || '',
    autoResolved:
      autoResolvedInputs.has(name) || Boolean(storedPromptedInputs.find((input) => input.name === name)?.autoResolved),
  }))
}

export default getDisplayPromptedInputs
